import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("urlAsaas");

const reqServiceAssas = {
	status: async function (body) {
		return apiServer
			.get("asaas/v1/service/status", {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqServiceAssas;
